export default "__VITE_ASSET__j$lsj5AO__"